// add_tracking_links_page.js

import TrackingLinksUtils from './tracking_links_utils';
import { validate_link } from './link_validations';

document.addEventListener('alpine:init', () => {
    Alpine.data('prefix_add_tracking_links_x_data', () => {
        // Get data from the template tag
        const template = document.getElementById('prefix-add-tracking-links-data');
        const distribution_links = JSON.parse(template.dataset.distributionLinks);
        const all_distribution_platforms = JSON.parse(template.dataset.allDistributionPlatforms);
        const link_type = template.dataset.linkType;
        const episode_id = template.dataset.episodeId;
        const authenticity_token = template.dataset.authenticityToken;
        const batch_update_url = template.dataset.batchUpdateUrl;
        const redirect_url = template.dataset.redirectUrl;
        const tracking_link_ids = JSON.parse(template.dataset.trackingLinkIds || '[]');

        // Initialize data using shared utilities
        const data = TrackingLinksUtils.createInitialData();
        Object.assign(data, {
            distribution_links: distribution_links,
            all_distribution_platforms: all_distribution_platforms,
            redirect_only: false,
            selected_youtube_url: false,
            backup_distribution_links: [],
            backup_options: [],
        });

        return {
            ...data,
            init() {
                this.linkSelector = document.querySelector("#link-selector");

                // Store the original data from the template BEFORE any processing
                this.backup_distribution_links = JSON.parse(JSON.stringify(distribution_links));
                this.backup_all_distribution_platforms = JSON.parse(JSON.stringify(all_distribution_platforms));

                this.create_arrays();

                // Store the processed data after create_arrays
                this.backup_processed_distribution_links = this.distribution_links_truth.map(link => ({
                    name: link.name,
                    pattern: link.pattern,
                    url: link.url,
                    title: link.title || ''
                }));
                this.backup_processed_options = this.add_more_options.map(option => ({
                    name: option.name,
                    pattern: option.pattern
                }));

                this.$watch('redirect_only', value => {
                    this.redirect_only_changed();
                });
            },
            redirect_only_changed() {
                if (this.redirect_only) {
                    const linksContainer = document.querySelector("#links-container");
                    if (linksContainer) {
                        linksContainer.innerHTML = '';
                    }
                    this.distribution_links_truth = [];
                    this.existing_links_to_delete = [];
                    this.add_more_options = this.all_distribution_platforms.map(option => ({
                        name: option.name,
                        pattern: option.pattern
                    }));
                    this.error_text = '';
                    this.build_options_list();
                } else {
                    // Restore processed data when redirect_only is disabled
                    this.distribution_links_truth = this.backup_processed_distribution_links.map(link => ({
                        name: link.name,
                        pattern: link.pattern,
                        url: link.url,
                        title: link.title || ''
                    }));
                    this.add_more_options = this.backup_processed_options.map(option => ({
                        name: option.name,
                        pattern: option.pattern
                    }));
                    this.error_text = ''; // Only reset error text when switching back to normal mode
                    if (this.distribution_links_truth.length > 0) {
                        this.create_link_elements();
                    } else {
                        this.create_empty_link_elements();
                    }
                    this.build_options_list();
                }
            },
            create_arrays() {
                TrackingLinksUtils.createArrays(this, this.distribution_links, this.all_distribution_platforms);
                this.build_options_list();

                if (this.distribution_links_truth.length > 0) {
                    this.create_link_elements();
                } else {
                    this.create_empty_link_elements();
                }
            },
            create_link_elements() {
                const linksContainer = document.querySelector("#links-container");
                linksContainer.innerHTML = '';
                for (let i = 0; i < this.distribution_links_truth.length; i++) {
                    const link = this.distribution_links_truth[i];
                    if (link.url !== "") {
                        if (link.name === "Custom") {
                            linksContainer.innerHTML += `
                <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm">${link.name}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="flex space-x-2 w-full">
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" id="${link.pattern}-title" type="text" class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" placeholder="Enter the name to be displayed" value="${link.title}">
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' && validate_link('${link.pattern}', $event.target.value) === true ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" id="${link.pattern}-url" type="text" class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" placeholder="Copy and paste your custom link" value="${link.url}">
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                        </div>
                        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              `;
                        } else {
                            linksContainer.innerHTML += `
                <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm">${link.name}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="relative rounded-md shadow-sm w-full"
                          x-data="{ url: '${link.url}', is_valid: validate_link('${link.pattern}', '${link.url}') }"
                          x-init="$watch('url', value => { is_valid = value === '' ? null : validate_link('${link.pattern}', value) })"
                        >
                          <input
                            x-model="url"
                            id="${link.pattern}-url"
                            autocomplete="off"
                            type="text"
                            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
                            placeholder="Copy and paste your ${link.name} link" value="${link.url}">
                          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                            </svg>
                          </div>
                          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                              <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              `;

                        }
                    }
                }
            },
            create_empty_link_elements() {
                const linksContainer = document.querySelector("#links-container");
                linksContainer.innerHTML = '';

                // Don't create any default items in redirect_only mode
                if (this.redirect_only) {
                    return;
                }

                let default_items = [
                    {name: "Apple Podcasts", pattern: "itunes_url", url: ""},
                    {name: "Spotify", pattern: "spotify_url", url: ""},
                    {name: "YouTube", pattern: "youtube_url", url: ""}
                ];

                for (let i = 0; i < default_items.length; i++) {
                    const link = default_items[i];
                    this.distribution_links_truth.push({
                        name: link.name, pattern: link.pattern, url: "",
                    });
                    linksContainer.innerHTML += `
            <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
              <div class="flex space-x-4 items-center">
                <div class="w-12 h-12">
                  <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                </div>
                <div class="flex flex-col flex-1 space-y-2">
                  <div class="font-bold text-sm">${link.name}</div>
                  <div class="flex space-x-2 items-center">
                    <div class="relative rounded-md shadow-sm w-full"
                      x-data="{ url: '', is_valid: null }"
                      x-init="$watch('url', value => { is_valid = value === '' ? null : validate_link('${link.pattern}', value) })">
                      <input
                        x-model="url"
                        id="${link.pattern}-url"
                        autocomplete="off"
                        type="text"
                        class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
                        placeholder="Copy and paste your ${link.name} link"
                      >
                      <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                        </svg>
                      </div>
                      <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === false">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                          <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14 11V17M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          `;
                    TrackingLinksUtils.removeFromOptionsList(this.add_more_options, link.pattern);
                }
            },
            delete_link(name, pattern) {
                TrackingLinksUtils.deleteLink(this, name, pattern);
                // Update backup data after deletion
                this.update_backup_data();
            },
            add_to_options_list(name, pattern) {
                TrackingLinksUtils.addMoreOptions(this, name, pattern);
            },
            remove_from_options_list(pattern) {
                TrackingLinksUtils.removeFromOptionsList(this.add_more_options, pattern);
            },
            build_options_list() {
                TrackingLinksUtils.buildOptionsList(this.add_more_options);
            },
            handle_add_more() {
                // Only allow one link in redirect_only mode
                if (this.redirect_only) {
                    // Check for existing links in the DOM
                    const existingLinks = document.querySelectorAll(".ql-link-el");
                    if (existingLinks.length >= 1) {
                        this.error_text = 'You can only add one app link in redirect mode.';
                        return;
                    }
                }
                this.error_text = '';

                if (this.redirect_only) {
                    // In redirect mode, show all available platforms
                    this.handle_add_more_redirect_mode();
                } else {
                    // Normal mode - use existing logic
                    TrackingLinksUtils.handleAddMore(this);
                }
            },
            handle_add_more_redirect_mode() {
                const linkSelector = document.querySelector("#link-selector");
                if (!linkSelector) return;

                // Build options list with all available platforms
                linkSelector.innerHTML = `<option value="">Select a listening app</option>`;

                // Use all_distribution_platforms instead of add_more_options
                for (let i = 0; i < this.all_distribution_platforms.length; i++) {
                    const platform = this.all_distribution_platforms[i];
                    linkSelector.innerHTML += `<option value="${platform.pattern}">${platform.name}</option>`;
                }

                const handleItemAdd = (value, item) => {
                    this.distributionLinkSelector.clear();
                    this.distributionLinkSelector.destroy();
                    this.selectorVisible = false;
                    linkSelector.classList.add("hidden");
                    TrackingLinksUtils.createLinkElement(value, item, this);
                    
                    // In redirect mode, set up a watcher to capture the URL
                    if (this.redirect_only) {
                        setTimeout(() => {
                            const urlInput = document.querySelector(`#${value}-url`);
                            if (urlInput) {
                                urlInput.addEventListener('input', (e) => {
                                    this.redirect_url_string = e.target.value;
                                });
                            }
                        }, 100);
                    }
                };

                const handleBlur = () => {
                    this.distributionLinkSelector.clear();
                    this.distributionLinkSelector.destroy();
                    this.selectorVisible = false;
                    linkSelector.classList.add("hidden");
                };

                linkSelector.classList.remove("hidden");
                this.distributionLinkSelector = new TomSelect("#link-selector", {create: false});
                this.selectorVisible = true;
                this.distributionLinkSelector.on("item_add", handleItemAdd);
                this.distributionLinkSelector.on("blur", handleBlur);
            },
            sync_options() {
                TrackingLinksUtils.syncOptions(this.selectorVisible, this.distributionLinkSelector);
            },
            create_link_element(value, item) {
                TrackingLinksUtils.createLinkElement(value, item, this);
                // Update backup data after adding a new link
                this.update_backup_data();
            },
            submit() {
                TrackingLinksUtils.submit(this, {
                    authenticity_token,
                    batch_update_url,
                    link_type,
                    episode_id,
                    redirect_url,
                    tracking_link_ids,
                    checkEmptyUrls: false // Add page doesn't require empty URL validation
                });
            },
            set_error_message(pattern) {
                this.error_text = TrackingLinksUtils.setErrorMessage(this.all_distribution_platforms, pattern);
            },
            clear_error_message() {
                TrackingLinksUtils.clearErrorMessage(this);
            },
            update_backup_data() {
                // Update backup data with current state (only when not in redirect_only mode)
                if (!this.redirect_only) {
                    this.backup_processed_distribution_links = this.distribution_links_truth.map(link => ({
                        name: link.name,
                        pattern: link.pattern,
                        url: link.url,
                        title: link.title || ''
                    }));
                    this.backup_processed_options = this.add_more_options.map(option => ({
                        name: option.name,
                        pattern: option.pattern
                    }));
                }
            },
        };
    });
});
